export enum HTTPErrorTypes {
  ACCOUNT_DEACTIVATED = 'account_deactivated',
  INVALID_GRANT = 'invalid_grant',
  ACCOUNT_NOT_FOUND = 'account_not_found',
  ACCOUNT_LOCKED = 'account_locked',
}
